var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataBase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#DDE7F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.5C16 19.4946 17.0536 20.4484 18.9289 21.1517C20.8043 21.8549 23.3478 22.25 26 22.25C28.6522 22.25 31.1957 21.8549 33.0711 21.1517C34.9464 20.4484 36 19.4946 36 18.5C36 17.5054 34.9464 16.5516 33.0711 15.8483C31.1957 15.1451 28.6522 14.75 26 14.75C23.3478 14.75 20.8043 15.1451 18.9289 15.8483C17.0536 16.5516 16 17.5054 16 18.5Z",
    stroke: "#0857C3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.5V26C16 26.9946 17.0536 27.9484 18.9289 28.6517C20.8043 29.3549 23.3478 29.75 26 29.75C28.6522 29.75 31.1957 29.3549 33.0711 28.6517C34.9464 27.9484 36 26.9946 36 26V18.5",
    stroke: "#0857C3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26V33.5C16 34.4946 17.0536 35.4484 18.9289 36.1517C20.8043 36.8549 23.3478 37.25 26 37.25C28.6522 37.25 31.1957 36.8549 33.0711 36.1517C34.9464 35.4484 36 34.4946 36 33.5V26",
    stroke: "#0857C3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataBase);
export default __webpack_public_path__ + "static/media/DataBase.babd3ac979f30713253abb68ff168827.svg";
export { ForwardRef as ReactComponent };